import api from "@/modules/order/services/order";
import moment from "moment";

const state = () => ({
    orders: [],
    order:{},
    todos:[],
    doings:[],
    dones:[],
    close:[],
    apiRslt: {
        fetch: {
            inProgress: false,
            success: false,
            error: false,
        }
    }
})

const getters = {
}

const actions = {
    loadOrders({commit}) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getOrders("order").then(result => {
            commit('SAVE_ORDER', result.data);
            commit('SET_API_DATA_FETCH_SUCCESS')
        }).catch(error => {
            commit('SET_API_DATA_FETCH_ERROR')
            throw new Error(`API ${error}`);
        });
    },
    getOneOrder({commit},payload) {
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getOrder(payload).then(result => {
            commit('SAVE_ONE_ORDER', result.data);
            commit('SET_API_DATA_FETCH_SUCCESS')
        }).catch(error => {
            commit('SET_API_DATA_FETCH_ERROR')
            throw new Error(`API ${error}`);
        });
    },
    refund({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.askRefund(payload.id)
            .then(() => {
                commit('SET_API_DATA_FETCH_SUCCESS')
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION004', extra: 'client' },{ root:true })
                location.reload();
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION004', extra: 'client' },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    partialRefund({ commit,dispatch }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.askPartialRefund(payload)
            .then(() => {
                commit('SET_API_DATA_FETCH_SUCCESS')
                //location.reload();
                dispatch('notifications/postToChannel', {code: 'VALIDNOTIFICATION005', extra: 'remboursement', id: payload.id },{ root:true })
            })
            .catch((e) => {
                dispatch('notifications/postToChannel', {code: 'ERRNOTIFICATION005', extra: 'remboursement', id: payload.id },{ root:true })
                commit('SET_API_DATA_FETCH_ERROR',e)

            });
    },

    /** Sleeeping code */
    stateOrderBasic({ commit }, payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.changeStateOrder(payload.id,payload)
            .then(() => {
                commit('SET_API_DATA_FETCH_SUCCESS')
            })
            .catch((e) => {
                commit('SET_API_DATA_FETCH_ERROR',e)
            });
    },
    switchOrderList({ commit, dispatch },payload){
        const date = new Date();
        const dateTime = moment(date).format("YYYY-MM-DD HH:mm:ss");
        if (payload.target === 'doing') dispatch('stateOrderBasic', {id: payload.object.id, state: 3 })
        if (payload.target === 'done') dispatch('stateOrderBasic', {id: payload.object.id, state: 4, readyAt: dateTime})
        if (payload.target === 'close') dispatch('stateOrderBasic', {id: payload.object.id, state: 5})

        commit('DELETE_' + payload.origin.toUpperCase(), payload.object.id)
        commit('ADD_' + payload.target.toUpperCase(), payload.object)
    },
    loadTodo({ commit },payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getOrderOutlet(payload,2)
            .then(r => {
                commit('LOAD_TODO', r.data)
                commit('SET_API_DATA_FETCH_SUCCESS')
            }).catch(error => {
                commit('SET_API_DATA_FETCH_ERROR')
                throw new Error(`API ${error}`);
            });

    },
    loadDoing({ commit },payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getOrderOutlet(payload,3)
            .then(r => {
                commit('LOAD_DOING', r.data)
                commit('SET_API_DATA_FETCH_SUCCESS')
            }).catch(error => {
            commit('SET_API_DATA_FETCH_ERROR')
            throw new Error(`API ${error}`);
        });
    },
    loadDone({ commit },payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.getOrderOutlet(payload,4)
            .then(r => {
                commit('LOAD_DONE', r.data)
                commit('SET_API_DATA_FETCH_SUCCESS')
            }).catch(error => {
            commit('SET_API_DATA_FETCH_ERROR')
            throw new Error(`API ${error}`);
        });
    },
    addComment({ commit },payload){
        commit('SET_API_DATA_FETCH_IN_PROGRESS')
        api.postComment(payload.obj)
            .then(r => {
                commit('ADD_COMMENT_ORDER',{data: r.data, id: payload.id, list: payload.list})
                commit('SET_API_DATA_FETCH_SUCCESS')
            }).catch(error => {
            commit('SET_API_DATA_FETCH_ERROR')
            throw new Error(`API ${error}`);
        });
    }
}

const mutations = {
    ADD_COMMENT_ORDER(state,payload){
        state[payload.list].map(order => {
            if (order.id === payload.id) {
                order.commentsOrder.push(payload.data)
            }
        })
    },

    LOAD_TODO (state,payload){
        state.todos = payload
    },
    ADD_TODO(state, payload){
        state.todos.push(payload)
    },
    DELETE_TODO (state, id){
        const index = state.todos.findIndex(c => c.id === id);
        state.todos.splice(index, 1);
    },

    LOAD_DOING (state,payload){
        state.doings = payload
    },
    ADD_DOING (state, payload){
        state.doings.push(payload)
    },
    DELETE_DOING (state, id){
        const index = state.doings.findIndex(c => c.id === id);
        state.doings.splice(index, 1);
    },

    LOAD_DONE (state,payload){
        state.dones = payload
    },
    ADD_DONE(state, payload){
        state.dones.push(payload)
    },
    DELETE_DONE(state, id){
        const index = state.dones.findIndex(c => c.id === id);
        state.dones.splice(index, 1);
    },
    ADD_CLOSE (state, payload){
        state.close.push(payload)
    },
    DELETE_CLOSE (state, id){
        const index = state.close.findIndex(c => c.id === id);
        state.close.splice(index, 1);
    },
    UPDATE_ORDER_TOTAL (state,payload){
        state.orders = state.orders.map(order => {
            if (order.id === payload.id) {
                return order.total = payload.total
            }
            return order
        })
    },
    SAVE_ORDER (state, orders) {
        state.orders = orders;
    },
    SAVE_ONE_ORDER (state, order) {
        state.order = order;
    },
    CHANGE_STATUS_CURR_ORDER(state,payload){
        const index = state.orders.findIndex(c => c.id === payload.id);
        state.orders[index].state = payload.state
    },

    SET_API_DATA_NO_FETCH: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },

    SET_API_DATA_FETCH_IN_PROGRESS: (state) => {
        state.apiRslt.fetch.inProgress = true
        state.apiRslt.fetch.completed = false
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_SUCCESS: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = true
        state.apiRslt.fetch.error = false
    },
    SET_API_DATA_FETCH_ERROR: (state) => {
        state.apiRslt.fetch.inProgress = false
        state.apiRslt.fetch.completed = true
        state.apiRslt.fetch.success = false
        state.apiRslt.fetch.error = true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
